import { createAction } from 'redux-act';

export const setQuestionState = createAction('set question state');
export const resetQuestionState = createAction('reset question state');
export const setQuestionProgress = createAction('set question progress');
export const resetQuestionProgress = createAction('reset question progress');
export const resetDayProgress = createAction('reset day progress');
export const setQuestionSuggest = createAction('set question suggest');
export const resetQuestionSuggest = createAction('reset question suggest');
export const setDayProgress = createAction('set day progress');
export const restoreData = createAction('restore user data');
export const setData = createAction('set user data');
export const resetData = createAction('reset user data');
export const sendUpdateData = createAction('send update data');
export const successSendUpdateData = createAction('success send update data');
export const failSendUpdateData = createAction('fail send update data');
export const getProgressRank = createAction('get progress rank');
export const failGetProgressRank = createAction('fail get progress rank');
export const successGetProgressRank = createAction('success get progress rank');
export const updatePrintCount = createAction('update print count');
export const uploadSearchKeyword = createAction('update search keyword');
export const getDayProgressSummary = createAction('get progress summary');
export const failGetDayProgressSummary = createAction(
  'fail get progress summary'
);
export const successGetDayProgressSummary = createAction(
  'success get progress summary'
);



// WEBPACK FOOTER //
// ./src/actions/user-data.js